import {create} from "zustand";
import axios from "axios";
import config from "../config/config.json";

const ProjectTeamStore = (set, get) => ({

    teamMembers: [],
    isLoading: false,
    error: null,
    projectID: null,

    setProjectID: (projectID) => set({ projectID: projectID }),

    loadTeamForProject: async (projectID) => {
        set({ isLoading: true, error: null, projectID: projectID });

        try {
            const response = await axios.get(
                config.API_URL + 'project/' + projectID + '/team',
                {headers: {'x-api-key': sessionStorage.getItem("apiKEY")}}
            );

            set({ teamMembers: response.data || [], isLoading: false });
        } catch (error) {
            set({ error: error.message, isLoading: false, teamMembers: [] });
        }
    },

    addTeamMember: async (projectID, userID) => {
        set({ isLoading: true, error: null });

        try {
            await axios.put(
                config.API_URL + 'project/' + projectID + '/team',
                { UserID: userID },
                {headers: {'x-api-key': sessionStorage.getItem("apiKEY")}}
            );

            get().loadTeamForProject(projectID);
        } catch (error) {
            set({ error: error.message, isLoading: false });
            throw error;
        }
    },

    removeTeamMember: async (teamMemberID) => {
        set({ isLoading: true, error: null });

        try {
            await axios.delete(
                config.API_URL + 'project/team/' + teamMemberID,
                {headers: {'x-api-key': sessionStorage.getItem("apiKEY")}}
            );

            const projectID = get().projectID;
            if (projectID) {
                get().loadTeamForProject(projectID);
            }
        } catch (error) {
            set({ error: error.message, isLoading: false });
        }
    },

    clearTeam: () => {
        set({ teamMembers: [], projectID: null, error: null });
    }

})

const useProjectTeamStore = create(ProjectTeamStore)

export default useProjectTeamStore
